import React, { useState, useEffect, useRef } from 'react'

const CountDown = ({isArabic}) => {
    const textRefs = useRef([]);
    const calculateTimeLeft = () => {
        const targetDate = new Date('2025-01-03T20:00:00+02:00');
        const now = new Date();
        const difference = targetDate - now;
    
        let timeLeft = {};
    
        if (difference > 0) {
          timeLeft = {
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / 1000 / 60) % 60),
            seconds: Math.floor((difference / 1000) % 60),
          };
        }
    
        return timeLeft;
      };
      const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

      useEffect(() => {
        const timer = setInterval(() => {
          setTimeLeft(calculateTimeLeft());
        }, 1000);
    
        return () => clearInterval(timer); // Cleanup the interval on component unmount
      }, []);
  return (
    <div className='my-4 pb-3 md:my-2'>
        {/* Countdown Timer */}
      <div className={`flex  ${isArabic&&'flex-row-reverse'} justify-evenly w-full items-center gap-4 text-center text-3xl md:text-5xl font-bold    md:my-10`}>
        <div ref={(el) => (textRefs.current[7] = el)} className="flex flex-col">
          <span className='text-3xl md:text-5xl'>{timeLeft.days || 0}</span>
          <span className="text-sm md:text-lg">{isArabic ? "أيام" : "Days"}</span>
        </div>
        <div ref={(el) => (textRefs.current[11]=el)} className='text-3xl md:text-5xl'>:</div>
        <div ref={(el) => (textRefs.current[8] = el)} className="flex flex-col">
          <span className='text-3xl md:text-5xl'>{timeLeft.hours || 0}</span>
          <span className="text-sm md:text-lg">{isArabic ? "ساعات" : "Hours"}</span>
        </div>
        <div ref={(el) => (textRefs.current[12]=el)}  className='text-3xl md:text-5xl'>:</div>
        <div ref={(el) => (textRefs.current[9] = el)} className="flex flex-col">
          <span className='text-3xl md:text-5xl'>{timeLeft.minutes || 0}</span>
          <span className="text-sm md:text-lg">{isArabic ? "دقائق" : "Minutes"}</span>
        </div>
        
      </div>
    </div>
  )
}

export default CountDown